import React, { useContext, useState } from 'react';
import ReactDOM from 'react-dom';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import List from '../../../../../Templates/List';
import { __OBJECT_STRUCTURE_GetGAP } from '../../../../../../common/ObjectStructures/sKPI';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import './style.css'
import { ActionButton, IconButton, MessageBarType, SpinnerSize } from '@fluentui/react';
import { getGridLocalization, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../../../common/Helpers';
import SidePanelSelectEndDateEP from './SidePanelSelectEndDateEP';
import { generateNewEdp, validateContractEdPOnPreparation } from '../../../../../../services/sPay/edpConfig.service';
import { useOfCheckIfNewEdPDateNeeded } from '../../../../../../hooks/component/sPay/useOfContractParties';
import { useCheckIfExistEdPOnPreparation } from '../../../../../../hooks/services/sPay/useOfEdPConfiguration';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { __enum_PageMode, __MessageTypes, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import Loading from '../../../../../Templates/Site/Loading';
import MainAppContext from '../../../../../../MainAppContext';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import BoardAppContext from '../../../../../../BoardAppContext';
import { useGetUserPropsKpi } from '../../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { useSelector } from 'react-redux';

function ELEMENT_CONTRACT_LIST_LAST_EDP(props) {
    const { t, i18n } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const { token: currentAuth } = useSelector((state) => state.auth);

    const { 
        inputParam_HideHeader = false,
        inputParam_ElementId = null,
        inputParam_ComponentContent = null,
        inputParam_UseFake = false,
        inputParam_UserPropsKpi = null,

    } = props;

    const [data, setData] = useState(__OBJECT_STRUCTURE_GetList(15, !inputParam_UseFake ? inputParam_ComponentContent?.items : [{
        nroEp: '--',
        periodo: '--',
        estado: '--',
        montoBase: 0,
        montoReajuste: 0,
        montoPago: 0,
        montoSaldoContrato: 0,
        currency: '--'
    }]))

    const [executingProcess, setExecutingProcess] = useState(false);
    const [edpDateNeeded, setEdpDateNeeded] = useState(undefined);
    const [nextValidEdpDate, setNextValidEdpDate] = useState(null);
    
    const [existEdP, setExistEdP] = useState(null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });




    const [isNewEdpSelectedDatePanelOpen, setIsNewEdpSelectedDatePanelOpen] = useState(false);

    const _priv_canPrepareEP = _checkSecurityUser(contextSite.onlyObserver, inputParam_UserPropsKpi, contextSite.securityProps, parseInt(inputParam_ElementId), enum__PRIVILEGES.EDP_PREPARAR);
    const canPrepareEp = (_priv_canPrepareEP.value && _priv_canPrepareEP.mode === __enum_PageMode.Edit)
    const _priv_canAddNewEp = _checkSecurityUser(contextSite.onlyObserver, inputParam_UserPropsKpi, contextSite.securityProps, parseInt(inputParam_ElementId), enum__PRIVILEGES.EDP_PREPARAR);
    const canAddNewEp = (_priv_canAddNewEp.value && _priv_canAddNewEp.mode === __enum_PageMode.Edit)
    const _priv_canConfigureEp = _checkSecurityUser(contextSite.onlyObserver, inputParam_UserPropsKpi, contextSite.securityProps, parseInt(inputParam_ElementId), enum__PRIVILEGES.EDP_CONFIG);
    const canConfigureEp = (_priv_canConfigureEp.value && _priv_canConfigureEp.mode === __enum_PageMode.Edit)
    


    const onGoToPrepareEdP = (item) => {
        window.open(`/PrepareEdP/${inputParam_ElementId}/${item.id}`)
    }

    useOfCheckIfNewEdPDateNeeded(inputParam_ElementId, edpDateNeeded, setEdpDateNeeded, setNextValidEdpDate);
    useCheckIfExistEdPOnPreparation(inputParam_ElementId, existEdP, setExistEdP)

    const handleOnGoToConfigureEP = () => {
	    window.location.href = `/ConfigureEdP/${inputParam_ElementId}`
    }

    const handleOnGoToPrepareEP = async () => {
        setExecutingProcess(true);
        await validateContractEdPOnPreparation(inputParam_ElementId).then(async (responseCheckEdpOnPreparation) => {
            if (responseCheckEdpOnPreparation.data.succeeded) {
                if (!responseCheckEdpOnPreparation.data.data.result_edp && !responseCheckEdpOnPreparation.data.data.result_inconsistencia) {
                    await generateNewEdp(inputParam_ElementId, null).then(async (response) => {
                        if (response.data.succeeded) {
                            if (response.data.data.result) {
                                window.location.href = `/PrepareEdP/${inputParam_ElementId}/${response.data.data.itemId}`
                            }
                            else {
                                if (response.data.data.l_validations.length > 0) {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_validations)
                                }
                                else {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                                }
                            }
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                        }
                    }).catch(() => {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    });
                }
                else {
                    if (responseCheckEdpOnPreparation.data.data.l_validations.length > 0) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, responseCheckEdpOnPreparation.data.data.l_validations)
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    }
                }
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
            }
            setExecutingProcess(false);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
            setExecutingProcess(false);
        });
    }

    const handleOnGoToNewEP = async () => {
        setExecutingProcess(true);
        await validateContractEdPOnPreparation(inputParam_ElementId).then(async (responseCheckEdpOnPreparation) => {
            if (responseCheckEdpOnPreparation.data.succeeded) {
                if (!responseCheckEdpOnPreparation.data.data.result_edp && !responseCheckEdpOnPreparation.data.data.result_inconsistencia) {
                    const needEndDate = true;
                    if (needEndDate) {
                        setIsNewEdpSelectedDatePanelOpen(true)
                    }
                    else {
                        await generateNewEdp(inputParam_ElementId, null).then(async (response) => {
                            if (response.data.succeeded) {
                                window.location.href = `/PrepareEdP/${inputParam_ElementId}/${response.data.data}`
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                            }
                        }).catch(() => {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                        });
                    }     
                }
                else {
                    if (responseCheckEdpOnPreparation.data.data.l_validations.length > 0) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, responseCheckEdpOnPreparation.data.data.l_validations)
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    }
                }
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
            }
            setExecutingProcess(false);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
            setExecutingProcess(false);
        });
    }

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return data.data[rowIndex.boundindex].id;
        }
        return data.data[rowIndex]?.id;
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource);
        const currentItem = data.data.find(x => x.id === itemId);

        return  <IconButton iconProps={{ iconName: 'View' }} onClick={() => onGoToPrepareEdP(currentItem)} allowDisabledFocus />
    };


    const renderContent = () => {
        return  <JqxGrid
                    altrows={true}
                    enabletooltips={true}
                    width={'100%'}
                    theme={'light'} 
                    autoheight={false}
                    height={'100%'}
                    editable={false}
                    pageable={false}
                    sortable={false}
                    filterable={false}
                    showfilterrow={false} 
                    localization={getGridLocalization(t)}
                    source={ new jqx.dataAdapter({
                        localData: data.data,
                        dataType: 'array',
                        dataFields: [
                            { name: 'id',                 type: 'number' },
                            { name: 'nroEp',              type: 'number' },
                            { name: 'periodo',            type: 'string' },
                            { name: 'etapaFlujo',         type: 'string' },
                            { name: 'currency',           type: 'string' },
                            { name: 'amount',             type: 'float' },
                            { name: 'montoBase',          type: 'float' },
                            { name: 'montoReajuste',      type: 'float' },
                            { name: 'montoPago',          type: 'float' },
                            { name: 'montoSaldoContrato', type: 'float' },
                        ],
                        id: 'id'
                    })}
                    columns={[
                        { index: null, text: t('data-lang-lbl-actions'),         dataField: 'acciones',           width: '50px', pinned: true,
                            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                        },
                        { index: null, text: 'ID',                                   dataField: 'id',                 width: '0px',  columntype: 'textbox', editable: false, pinned: true, hidden: true },
                        { index: 0,    text: 'N° EP',                                dataField: 'nroEp',              width: '60px',  columntype: 'textbox', editable: false, pinned: true },
                        { index: 1,    text: t('data-lang-lbl-monthep'),             dataField: 'periodo',            width: '100px',  columntype: 'textbox', editable: false, pinned: true },
                        { index: 2,    text: t('data-lang-lbl-epcondition'),         dataField: 'etapaFlujo',         width: '120px', columntype: 'textbox', editable: false, pinned: true },
                        { index: 4,    text: t('data-lang-lbl-paymentamount'),       dataField: 'montoPago',          width: '160px', columntype: 'textbox', editable: false, cellsalign: 'right', cellsformat: 'n2', },
                        { index: 5,    text: t('data-lang-lbl-baseamount'),          dataField: 'montoBase',          width: '160px', columntype: 'textbox', editable: false, cellsalign: 'right', cellsformat: 'n2', },
                        { index: 6,    text: t('data-lang-lbl-amountreset'),         dataField: 'montoReajuste',      width: '160px', columntype: 'textbox', editable: false, cellsalign: 'right', cellsformat: 'n2', },
                        { index: 7,    text: t('data-lang-lbl-contracttotalamount'), dataField: 'amount',             width: '160px', columntype: 'textbox', editable: false, cellsalign: 'right', cellsformat: 'n2', },
                        { index: 8,    text: t('data-lang-lbl-contractbalance'),     dataField: 'montoSaldoContrato', width: '160px', columntype: 'textbox', editable: false, cellsalign: 'right', cellsformat: 'n2', },
                        { index: 3,    text: t('data-lang-lbl-currency'),            dataField: 'currency',           width: '80px',  columntype: 'textbox', editable: false },
                    ]}
                />     
    }

    return (
        <>
            {
                !inputParam_UseFake &&
                <>
                    <Card className='h-100 pb-2'>
                        {
                            !inputParam_HideHeader &&
                            <Card.Header className="card-header-compact">
                                <Card.Title className="d-flex justify-content-between">
                                    <b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-boxname-lasteps')}</b>
                                    <div className='toolbar d-flex'>
                                    </div>
                                    <Row>
                                        {
                                            !executingProcess &&
                                            <Col>
                                                {
                                                    edpDateNeeded !== undefined && existEdP === false &&
                                                    <>
                                                        {
                                                            edpDateNeeded === true && canAddNewEp === true &&
                                                            <ActionButton text={t('data-lang-btn-newep')} onClick={handleOnGoToNewEP} iconProps={{iconName: "EntitlementPolicy"}} styles={{ icon: { fontSize: 20 } }} />
                                                        }
                                                        {
                                                            edpDateNeeded === false && canPrepareEp === true &&
                                                            <ActionButton text={t('data-lang-btn-prepareep')} onClick={handleOnGoToPrepareEP} iconProps={{iconName: "EntitlementPolicy"}} styles={{ icon: { fontSize: 20 } }} />
                                                        }
                                                    </>                                    
                                                }
                                                {
                                                    canConfigureEp === true &&
                                                    <ActionButton text={t('data-lang-btn-configureep')} onClick={handleOnGoToConfigureEP} iconProps={{iconName: "ConfigurationSolid"}} styles={{ icon: { fontSize: 20 } }} />
                                                }
                                            </Col>
                                        }
                                        {
                                            executingProcess &&
                                            <Col>
                                                <Loading
                                                    inputParam_Style={{marginTop: 0}}
                                                    inputParam_ShowLoading={true}
                                                    inputParam_ShowText={true}
                                                    inputParam_Text={t('data-lang-lbl-executing')}
                                                    inputParam_Position="unset"
                                                    inputParam_Width="20px"
                                                    inputParam_Height="20px"
                                                    inputParam_Vertical={false}
                                                    inputParam_ColClassName="my-auto"
                                                    inputParam_EjecutingTextClass={"ps-4"}
                                                    inputParam_Left="87%"
                                                    inputParam_Top="11px"
                                                    inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                                />
                                            </Col>
                                        }
                                    </Row>
                                </Card.Title>
                            </Card.Header>
                        }
                        <Card.Footer>
                            <MessageBox
                                inputParam_Message={ t('data-lang-msg-showingdatafromperiod') }
                                inputParam_Display={ true }
                                inputParam_MessageType={ MessageBarType.info }
                                inputParam_SetterMessage={ null }
                            />
                            <MessageBox
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </Card.Footer>
                        <Card.Body className='px-2 py-0 h-100'>
                            {renderContent()}
                        </Card.Body>
                    </Card>
                    {
                        nextValidEdpDate && isNewEdpSelectedDatePanelOpen &&
                        <SidePanelSelectEndDateEP
                            inputParam_ElementId={inputParam_ElementId}
                            inputParam_IsPanelOpen={isNewEdpSelectedDatePanelOpen}
                            inputParam_SetterIsPanelOpen={setIsNewEdpSelectedDatePanelOpen}
                            inputParam_NextValidEdpDate={nextValidEdpDate}
                        />
                    }
                </>
            }
            {
                inputParam_UseFake && renderContent()
            }
        </>
      );
}

ELEMENT_CONTRACT_LIST_LAST_EDP.propTypes = {
    
};

export default ELEMENT_CONTRACT_LIST_LAST_EDP;